module.exports = __webpack_public_path__ + "img/w3_rocket_white.fa9b42e4.png";